module.exports = __webpack_public_path__ + "static/img/header.afe61a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/header.png
// module id = lZ+P
// module chunks = 2